module.exports = {
  apiKey: "AIzaSyAtk4hWAZ1KkrYzf-YqVDdhYxlVM0FJUjw",
  authDomain: "king-of-football.firebaseapp.com",
  databaseURL: "https://king-of-football.firebaseio.com",
  projectId: "king-of-football",
  storageBucket: "king-of-football.appspot.com",
  messagingSenderId: "409054935993",
}
